import React from 'react';
import { useParams } from 'react-router-dom';
import { Typography } from 'antd';
import { VideoCameraOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const VideoEditor = () => {
    const { projectId } = useParams();

    return (
        <div style={{ width: '100%', height: 'calc(100vh - 64px)', overflow: 'hidden', background: '#000' }}>
            <iframe
                src={`http://localhost:3000`}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    display: 'block'
                }}
                title="Video Editor"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
};

export default VideoEditor;
